module.exports = __webpack_public_path__ + "static/DailyPay-2fc17f44341d7a1004048b6704ec335a.jpg";